// // // PrivateRoute.js
// // import React from 'react';
// // import {Navigate} from 'react-router-dom';
// // import {useAuth} from './AuthContext';
// //
// // const PrivateRoute = ({ element: Element, ...rest }) => {
// //     const { authToken } = useAuth();
// //
// //     return authToken?.token ? (
// //         <Element {...rest} />
// //     ) : (
// //         <Navigate to="/login" replace />
// //     );
// // };
// //
// // export default PrivateRoute;
//
// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';
//
// const PrivateRoute = ({ element: Component }) => {
//     const { authToken } = useAuth();
//
//     // Vérifier si l'utilisateur est connecté
//     if (!authToken.token) {
//         console.log("Accès refusé - non connecté");
//         return <Navigate to="/login" replace />;
//     }
//
//     console.log("Accès autorisé");
//     return <Component />;
// };
//
// export default PrivateRoute;
//
// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';
//
// const PrivateRoute = ({ element: Component }) => {
//     const { authToken, loading } = useAuth();
//
//     if (loading) return null;
//
//     return authToken.token ? <Component /> : <Navigate to="/login" replace />;
// };
//
// export default PrivateRoute;

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ element: Component }) => {
    const { authToken, loading } = useAuth();

    // Pendant que le token est en cours de vérification (chargement)
    if (loading) {
        return null; // Ou tu peux afficher un spinner si tu veux
    }

    // Si l'utilisateur est connecté
    if (authToken.token) {
        return <Component />;
    }

    // Sinon, rediriger vers la page de login
    return <Navigate to="/login" replace />;
};

export default PrivateRoute;
